<template>
  <div>
    <h1>Link do Organizador</h1>
    <p>{{ link }}</p>
  </div>
</template>

<script>
export default {
  name: 'Event',
  data () {
    return {
      event: '',
      eventId: parseInt(this.$route.params.id)
    }
  },
  mounted () {
    this.getEvent()
  },
  methods: {
    getEvent () {
      this.$http.get(process.env.VUE_APP_URL_APP + '/b/events/' + this.eventId).then(res => {
        this.event = res.body
      }, err => {
        console.log(err)
      })
    }
  },
  computed: {
    link () {
      let route = this.$router.resolve({
        name: 'OrganizerOverview',
        params: {organizer: this.event.token}
      })
      let href = route.href.substr(0, route.href.length - 1)
      return process.env.VUE_APP_URL_APP + href
    }
  }
}
</script>
